import { render, staticRenderFns } from "./vehicleCount.vue?vue&type=template&id=a5c70c3a"
import script from "./vehicleCount.vue?vue&type=script&lang=js"
export * from "./vehicleCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports